var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 420,
    viewBox: "0 0 240 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 156,
    width: 121,
    height: 24,
    rx: 10,
    fill: "#F4F4F4",
    stroke: "#D9D9DA",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 180,
    width: 101,
    height: 174,
    rx: 10,
    fill: "#F4F4F4",
    stroke: "#D9D9DA",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 193,
    width: 75,
    height: 102,
    rx: 5,
    fill: "white",
    stroke: "#D9D9DA",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 354,
    width: 121,
    height: 13,
    rx: 5,
    fill: "#F4F4F4",
    stroke: "#D9D9DA",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 154.5V54.5L133 81V154.5H106.5Z",
    fill: "url(#paint0_linear_1388_2070)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107 53L107 154",
    stroke: "#D9D9DA",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133 80L133 154",
    stroke: "#D9D9DA",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.941 226.297C113.581 228.538 109.084 234.334 108.21 241.418C108.023 242.931 108.121 246.372 108.394 247.839C109.023 251.232 110.426 254.654 112.416 257.657C113.385 259.12 114.042 259.953 116.733 263.136C120.539 267.638 122.777 271.135 123.48 273.68C124.286 276.593 124.266 280.031 123.421 284.298C123.059 286.125 123.095 286.398 123.757 286.81C124.259 287.123 124.772 287.066 126.438 286.513C130.859 285.045 134.687 281.673 136.873 277.319C140.243 270.609 139.575 261.958 135.106 254.424C133.623 251.924 132.2 250.094 129.44 247.134C123.441 240.702 122.26 238.226 122.242 232.042C122.238 230.697 122.302 229.02 122.386 228.317C122.515 227.218 122.512 226.989 122.359 226.697C121.949 225.91 121.33 225.808 119.941 226.297ZM105.35 259.804C104.515 260.23 103.42 261.169 102.745 262.035C101.603 263.501 101.001 265.348 101 267.392C100.998 270.341 102.004 272.68 104.607 275.776C107.892 279.683 108.494 281.126 108.194 284.382C108.04 286.043 108.125 286.321 108.882 286.635C109.24 286.783 109.36 286.78 109.863 286.61C111.338 286.114 113.127 284.501 113.949 282.926C114.842 281.214 115.012 280.465 115.001 278.273C114.993 276.553 114.959 276.259 114.666 275.303C113.957 272.994 112.763 271.032 110.739 268.848C107.989 265.88 107.451 264.744 107.464 261.928C107.471 260.35 107.327 259.909 106.72 259.657C106.156 259.423 106.078 259.432 105.35 259.804Z",
    fill: "#D9D9DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1388_2070",
    x1: 135,
    y1: 163.5,
    x2: 114.5,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.226972,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807413,
    stopColor: "#F4F4F4",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlaceholder);
export default __webpack_public_path__ + "static/media/product-placeholder.bebb16231ee5968e81f54be83a3fa304.svg";
export { ForwardRef as ReactComponent };